import React from 'react';
import './PopUp.css';

function PopUp(props) {
    return (
        <div className='PopUp complete__fadein'>
            <p>{props.data.name} added To your cart.</p>
        </div>
    )
}

export default PopUp
